export default __webpack_public_path__ + "static/media/water-outline.0cf89b06.svg";